const LS = {
  LAST_SENDED_MAIL: 'lastSendedMail',
  LAST_SENDED_PHONE: 'lastSendedPhone'
}

export { LS }
export default LS
